import { render, staticRenderFns } from "./invoice_verificate12306.vue?vue&type=template&id=f2b527a2&"
import script from "./invoice_verificate12306.vue?vue&type=script&lang=js&"
export * from "./invoice_verificate12306.vue?vue&type=script&lang=js&"
import style0 from "./invoice_verificate12306.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports